import moment from 'moment';
import { formatIsoDateTime } from 'utils/dates';
import Base from 'app/models/base';

export default Base.extend({
  initialize(options) {
    this.set('startDatetime', options.startDatetime || moment.utc().subtract(1, 'months').add(1, 'days').startOf('day'));
    this.set('endDatetime', options.endDatetime || moment.utc().startOf('day'));
  },

  getStartDatetimeForParam() {
    return moment(this.get('startDatetime')).utc().startOf('day');
  },

  getEndDatetimeForParam() {
    return moment(this.get('endDatetime')).utc().startOf('day');
  },

  getDayAfterEndDatetimeForParam() {
    return moment(this.get('endDatetime')).utc().startOf('day').add(1, 'days');
  },
  getStartDatetimeForParamIso() {
    return formatIsoDateTime(this.getStartDatetimeForParam());
  },
  getEndDatetimeForParamIso() {
    return formatIsoDateTime(this.getEndDatetimeForParam());
  },
  getDayAfterEndDatetimeForParamIso() {
    return formatIsoDateTime(this.getDayAfterEndDatetimeForParam());
  },
});



// WEBPACK FOOTER //
// ./app/models/date_range.js